import React from "react"
import { StyledAcerca } from "../styles/components"


export default function Acerca() {
  return (
    <StyledAcerca>
      <div>
        <h2>Hola soy Sandra Rairán!!!</h2>
        <small>Soy Ingeniería de sistemas con habilidades Machine Learning y Ciencia de Datos!!!
        </small>
      </div>
    </StyledAcerca>
  )
}